// removed by extract-text-webpack-plugin
module.exports = {"bannerWrap":"qempo_CustomBanner_bannerWrap-1d-GSj6","reverseWrap":"qempo_CustomBanner_reverseWrap-1-h7qMY","columnWrap":"qempo_CustomBanner_columnWrap-2rInbak","dualWrap":"qempo_CustomBanner_dualWrap-1F9O_-P","leftWrap":"qempo_CustomBanner_leftWrap-tWycnBM","contentWrapStyle":"qempo_CustomBanner_contentWrapStyle-8aUnIni","sideImage":"qempo_CustomBanner_sideImage-1O88-h4","rightWrap":"qempo_CustomBanner_rightWrap-qPBIYDn"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/CustomBanner/CustomBanner.scss
// module id = 1149
// module chunks = 0